import {
	Component, Input, Output, OnChanges, SimpleChanges,
	SimpleChange, EventEmitter, OnInit, HostListener
} from '@angular/core';


@Component({
    selector: 'user-type-info',
	templateUrl: './user-type-info.component.html',
	styleUrls: ['./user-type-info.component.scss']
})
export class UserTypeInfoComponent {

	constructor() {
		return;
	}

}